/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type SomniaContractInfo = {
    CNTRCTADDR: string;
    LBL: string;
    COMPVR: string;
    EVR: string;
    TRXCNT: string;
    TRXCNTCH: string;
    BAL: string;
    PRX: SomniaContractInfo.PRX;
    VA: number;
};

export namespace SomniaContractInfo {

    export enum PRX {
        Y = 'Y',
        N = 'N',
    }


}

